"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sant-angelo-in-vado": {
    "271508c2": [{
      "hkey": "4704b9b5",
      "slug": "sant-angelo-in-vado",
      "name": "Sant'Angelo in Vado",
      "primary": true,
      "skipSearch": false
    }],
    "passo-sant-angelo": [{
      "hkey": "4704b9b5",
      "slug": "sant-angelo-in-vado",
      "name": "Sant'Angelo in Vado",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;